import React from 'react'
import HomeSection from './homeSection'
import Homenewnew from './homenewnew'

export default function NewHome() {
  return (
    <div>
        {/* <SubNavbar/> */}
        {/* <HomeSection/> */}
        <Homenewnew/>
    </div>
  )
}
